export default (href, name) => {
  const tempLink = document.createElement("a");
  tempLink.style.display = "none";
  tempLink.href = href;
  tempLink.setAttribute("download", name);

  if (typeof tempLink.download === "undefined") {
    tempLink.setAttribute("target", "_blank");
  }

  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
};



// WEBPACK FOOTER //
// ./src/utils/download.js